import { render, staticRenderFns } from "./EleGalleryDialog.vue?vue&type=template&id=bfa03e68&"
import script from "./EleGalleryDialog.vue?vue&type=script&lang=js&"
export * from "./EleGalleryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports